// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const RoleHolderIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M16.5 1.5h-9c-3.24 0-5.4 2.27-5.4 5.63v7.58c0 3.35 2.16 5.52 5.4 5.52h1.96l2.05 2.05c.11.11.33.22.54.22s.44-.1.55-.22l1.94-2.05h1.95c3.25 0 5.42-2.28 5.42-5.52V7.13c0-3.36-2.17-5.63-5.42-5.63"
        opacity=".5"
      />
      <path d="M7.8 16.45h8.4c.28 0 .5-.23.5-.5 0-1.77-1.46-3.56-4.7-3.56s-4.7 1.8-4.7 3.58q0 .2.15.34t.34.14m7.26-8.61c0-1.69-1.37-3.05-3.05-3.05S8.95 6.15 8.95 7.84s1.37 3.04 3.05 3.04 3.05-1.36 3.05-3.04" />
    </g>
  </SvgIcon>
);

export default RoleHolderIcon;
